<template>
    <div>
        <!--Edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header">
                    <h3 class="fw-bold mb-3">Admin</h3>
                    <ul class="breadcrumbs mb-3">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Documentos Sinistro</a> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click="EditNew()">Incluir Novo</a> </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="ListaDocumento.docId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Nome</label>
                                            <input v-model="ListaDocumento.docNome"
                                                type="text" class="form-control" placeholder="Nome" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <div class="form-group">
                                            <label>Visivel</label>
                                            <select v-model="ListaDocumento.docVisivel" class="form-select form-control"
                                                id="defaultSelect">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="TipoPessoas != ''">
                                        <div class="form-group">
                                            <label>Tipo</label>
                                            <select  v-model="ListaDocumento.docTipo" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option v-for="optionTipo in TipoPessoas" :key="optionTipo.docTipo"
                                                    :value="optionTipo.docTipo">{{ optionTipo.docTipoNome }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action">
                        <button v-if="ListaDocumento.docId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()"  class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Lista de documentos</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body">
                                <v-row>
                                    <v-col cols="12" md="6" style="padding-bottom: 30px;">
                                        <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <easy-data-table :headers="headers" :items="ListaDocumentos" v-model="itemsSelected" alternating
                                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                                    <template #item-docVisivel="item">
                                        <span>{{ item.docVisivel ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                            <v-icon class="editiconcor">mdi-file-edit</v-icon>
                                            <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                                        </v-btn>

                                        <v-btn icon @click="DeleteGrid(item)" variant="text">
                                            <v-icon class="deliconcor">mdi-delete-forever</v-icon>
                                            <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                                        </v-btn>
                                    </template>
                                </easy-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'CadastroDocumentosSinistrosView',
    components: {
        EasyDataTable
    },
    data: () => ({
        EditView: false,
        ListaDocumento: {
            docId: 0,
            docNome: '',
            docVisivel: '',
            docTipo: '',
            docTipoNome:'',
            docAtivo: ''
        },
        ListaDocumentos: [],
        selectedVisivel: null,
        headers: [
            { text: "Id", value: "docId", sortable: true, },
            { text: "Nome", value: "docNome", sortable: true, },
            { text: "Visivel", value: "docVisivel", sortable: true, },
            { text: "Tipo", value: "docTipoNome", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
        TipoPessoas:[
            {docTipo: 1, docTipoNome: 'Cadastro Sinistro'},
            {docTipo: 2, docTipoNome: 'Débito Sinistro'},
            {docTipo: 3, docTipoNome: 'Envio Jurídico'}
        ],
    }),
    methods: {
          //edit
          EditNew(){
            this.EditView = true;
            this.ListaDocumento.docId = 0;
            this.ListaDocumento.docNome= '';
            this.ListaDocumento.docVisivel= '';
            this.ListaDocumento.docAtivo= '';
            this.ListaDocumento.docTipo= '';
            this.ListaDocumento.docTipoNome= '';
        },
        EditGrid(item) {
            this.EditView = true;
            if (item.docId != ''){
            axios.get(`/Telas/CadastroDocumentosSinistros/GetById/` + item.docId)
                .then(response => {
                    this.ListaDocumento = response.data;
                });
            }
        },
        Add() {
            if (this.ListaDocumento.docNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.ListaDocumento.docVisivel === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else {
                this.ListaDocumento.docAtivo = true;

                if (this.ListaDocumento.docTipo != null && this.ListaDocumento.docTipo != 0){
                  this.ListaDocumento.docTipoNome = this.TipoPessoas.filter(x=> x.docTipo == this.ListaDocumento.docTipo)[0].docTipoNome;
                }
                else{
                    this.ListaDocumento.docTipoNome = null;
                    this.ListaDocumento.docTipo = 0;
                }
                axios.post(`/Telas/CadastroDocumentosSinistros/Add`, this.ListaDocumento)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                        }
                    });
            }
        },
        Put() {
            if (this.ListaDocumento.docNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.ListaDocumento.docVisivel === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else {
                 this.ListaDocumento.docAtivo = true;
                if (this.ListaDocumento.docTipo != null && this.ListaDocumento.docTipo != 0){
                  this.ListaDocumento.docTipoNome = this.TipoPessoas.filter(x=> x.docTipo == this.ListaDocumento.docTipo)[0].docTipoNome;
                }
                else{
                    this.ListaDocumento.docTipoNome = null;
                    this.ListaDocumento.docTipo = 0;
                }
                axios.put(`/Telas/CadastroDocumentosSinistros/Update`, this.ListaDocumento)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                        }
                    });
            }
        },
        EditCancel(){
            //window.location.reload();
            this.$router.go(0);
        },
          //edit
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.docId;
                axios.delete(`/Telas/CadastroDocumentosSinistros/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                    }
                });
            }
            });
        },
        async Get() {
            this.EditView = false;
             await axios.get(`/Telas/CadastroDocumentosSinistros/GetDados`)
               .then(response => {
                this.ListaDocumentos = response.data.listaDocumento;
                console.log('this.ListaDocumentos')
                console.log(this.ListaDocumentos)
           });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
